import Permissions from '@app/src/auth/permissions'
import { usePermissions } from '@app/src/auth/permissions/usePermissions'
import React from 'react'

export interface HasWriteAccessProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export const HasWriteAccess: React.FC<HasWriteAccessProps> = ({ children, fallback = null }) => {
  const { hasPermission } = usePermissions()

  if (!hasPermission(Permissions.VIEW_ONLY_ACCESS)) {
    return <>{children}</>
  }

  return <>{fallback}</>
}

export default HasWriteAccess
